module.exports = {
  methods: {
    showHowItWorksModal: function() {
      return this.$events.emit('modal-touch-open', 'bucks-back-how-it-works-modal');
    }
  }
};

